import React from "react";
import { graphql, PageProps } from "gatsby";

import { SEO } from "../components/common/seo";
import { About } from "../components/Pages/About";

interface AboutDataProps {
  data: {
    frontmatter: {
      content: string;
    };
  };
}

const AboutPage: React.FC<PageProps<AboutDataProps>> = ({ data }) => {
  return (
    <>
      <SEO title="About" />

      <About content={data.data.frontmatter.content} />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default AboutPage;

export const query = graphql`
  query AboutQuery {
    data: markdownRemark(fileAbsolutePath: { regex: "/about.md/" }) {
      frontmatter {
        content
      }
    }
  }
`;
